// extracted by mini-css-extract-plugin
export default {"tooltip":"TooltipIcon_tooltip__4t7Mx","icon":"TooltipIcon_icon__8GU7U"};